const ButtonGrid = ({buttons, selected, setSelected, className}) => {
    return (
        <div className={`grid gap-3 ${className}`}>
            { buttons.map((button, index) => 
                <div onClick={() => setSelected(index)} style={button.style} className={`textSquareButton ${index == selected ? "textSquareButtonSelected" : ""}`}>
                    <p className="w-100p">{button.text}</p>
                </div>
            )}
        </div>
    )
}

export default ButtonGrid